import React from 'react';
import { Smartphone, Banknote } from 'lucide-react';

const OPTIONS = [
  { id: 'upi', label: 'UPI', Icon: Smartphone },
  { id: 'bank', label: 'Bank Transfer', Icon: Banknote },
];

export const PaymentMethodPicker = ({ value, onChange }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
    {OPTIONS.map(({ id, label, Icon }) => {
      const active = value === id;
      return (
        <label
          key={id}
          data-testid={`payment-method-${id}`}
          className={`flex flex-col items-center gap-1 p-3 border-2 rounded-lg cursor-pointer transition ${active ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-300'}`}
        >
          <input type="radio" name="pay" value={id} checked={active} onChange={() => onChange(id)} className="sr-only" />
          <Icon size={20} className={active ? 'text-orange-600' : 'text-gray-500'} />
          <span className="text-sm font-medium">{label}</span>
        </label>
      );
    })}
  </div>
);
